import React, { Fragment, useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'

import { Heading } from '../../../components/Text/Heading'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useStoreState, useStoreActions } from '@/store/store.hooks'
import { FacebookMessengerButton, ViberButton } from '@/components'
import { Divider } from '@material-ui/core'
import { normalizeLanguage } from '@/util'
import { NavigateBack } from '@/components/Nav/NavigateBack'
import { navigate } from '@reach/router'

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    margin: 0,
    backgroundColor: '#fff',
    borderRadius: '15px',
  },

  fullWidth: {
    width: '100%',
  },

  headingContainer: {
    textAlign: 'center',
    width: '100%',
  },

  internalContainer: {
    padding: '0 4rem 2rem 4rem',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',

    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },

  navigateBackContainer: {
    paddingTop: '1rem',
    marginTop: 0,
  },

  socialIcon: {
    display: 'flex',
    justifyContent: 'left',
  },
}))

const Contact = () => {
  const classes = useStyles()
  const {
    t,
    i18n: { language: lng },
  } = useTranslation('contact')
  const { account, subscriptionRetrieved } = useStoreState(
    (state) => state.subscription
  )
  const { fetchSubscription } = useStoreActions((state) => state.subscription)
  const [isBmw, setIsBmw] = useState(false)

  const quickAccessLink =
    normalizeLanguage(lng) === 'hu'
      ? 'https://dokiapp.hu/dokiapp-mobilon'
      : 'http://dokiapp.hu/dokiapp-shortcut'

  useEffect(() => {
    fetchSubscription()
  }, [])

  useEffect(() => {
    if (subscriptionRetrieved === true) {
      if (account && account.key === 'bmw-mental-health') {
        setIsBmw(true)
      }
    }
  }, [subscriptionRetrieved, account])

  const handleNavigateBack = () => {
    navigate('/')
  }

  return (
    <Fragment>
      <Grid item xs={12} className={classes.dashboardContainer}>
        <NavigateBack
          onBack={handleNavigateBack}
          className={classes.navigateBackContainer}
        />
        <div className={classes.internalContainer}>
          <div className={classes.headingContainer}>
            <Heading>{t<string>('heading')}</Heading>
          </div>

          <p>{t<string>('paragraph')}</p>

          {!isBmw && (
            <p>
              <b>{t<string>('corporateSubscriptionInfoHeader')}</b>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: t<string>('corporateSubscriptionInfoLine1'),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: t<string>('corporateSubscriptionInfoLine2'),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: t<string>('corporateSubscriptionInfoLine3'),
                  }}
                />
              </ul>
            </p>
          )}

          <Divider className={classes.fullWidth} />

          <p>
            <strong>{t<string>('technical')}</strong>
            <br />
            <b>{t<string>('email')}</b> support@dokiapp.hu
            <br />
            <b>{t<string>('phoneNumber')}</b>{' '}
            <a href="tel:+36300804066">+36&nbsp;30&nbsp;080&nbsp;4066</a>
          </p>

          <Grid container xs={12} md={8} spacing={3}>
            <Grid item xs={12} md={6} className={classes.socialIcon}>
              <FacebookMessengerButton>
                {t<string>('facebookMessenger')}
              </FacebookMessengerButton>
            </Grid>
            <Grid item xs={12} md={6} className={classes.socialIcon}>
              <ViberButton>{t<string>('viber')}</ViberButton>
            </Grid>
          </Grid>

          <p>{t<string>('text')}</p>

          <Divider className={classes.fullWidth} />

          <p>
            <strong>{t<string>('quickAccess')}</strong>
            <br />
            <a href={quickAccessLink} target="_blank" rel="nofollow noreferrer">
              {quickAccessLink}
            </a>
          </p>

          <Divider className={classes.fullWidth} />

          <p>
            <strong>{t<string>('general')}</strong> <br />
            hello@dokiapp.hu
          </p>

          <Divider className={classes.fullWidth} />

          <p>
            DokiLab Kft. <br />
            4400 Nyíregyháza, Kalevala sétány 51. <br />
            {t<string>('taxNum')} 27063804-2-15 <br />
            {t<string>('companyRegNum')} 15-09-086670
          </p>
        </div>
      </Grid>
    </Fragment>
  )
}

export { Contact }
